import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="contact-container">
      <header>
        <button class="btn-back" [routerLink]="['/']">
          <span class="material-symbols-outlined">arrow_back</span>
          {{ t('back') }}
        </button>
        <h1>{{ t('contact_title') }}</h1>
      </header>
      
      <div class="glass-card content">
        <p>{{ t('contact_intro') }}</p>
        
        <div class="contact-method">
            <span class="material-symbols-outlined icon">mail</span>
            <div class="details">
                <h3>Email</h3>
                <a href="mailto:support&#64;puzzlepractice.online">support&#64;puzzlepractice.online</a>
            </div>
        </div>

        <div class="info-note">
             <p>{{ t('contact_response_time') }}</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .contact-container {
        max-width: 800px;
        margin: 0 auto;
        padding: 2rem;
        min-height: 100vh;
    }
    header { margin-bottom: 2rem; }
    
    .btn-back {
      background: none;
      border: none;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 600;
      cursor: pointer;
      color: var(--text-muted);
      margin-bottom: 1rem;
      font-size: 1rem;
    }
    
    h1 { font-size: 2.5rem; color: var(--text-dark); margin-bottom: 0.5rem; }
    
    .content {
        padding: 3rem;
        display: flex;
        flex-direction: column;
        gap: 2rem;
    }
    
    .contact-method {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        padding: 1.5rem;
        background: rgba(255,255,255,0.5);
        border-radius: 16px;
        border: 1px solid rgba(0,0,0,0.05);
    }
    
    .icon {
        font-size: 2.5rem;
        color: var(--primary-pastel);
        background: white;
        padding: 1rem;
        border-radius: 50%;
        box-shadow: 0 4px 10px rgba(0,0,0,0.05);
    }
    
    .details h3 {
        margin: 0 0 0.5rem 0;
        font-size: 1.1rem;
        color: var(--text-muted);
    }
    
    .details a {
        font-size: 1.2rem;
        font-weight: 600;
        color: var(--text-dark);
        text-decoration: none;
        border-bottom: 2px solid var(--primary-pastel);
        transition: all 0.2s;
    }
    
    .details a:hover {
        background: var(--primary-pastel);
        color: white;
    }

    .info-note {
        font-size: 0.9rem;
        color: var(--text-muted);
        text-align: center;
        margin-top: 1rem;
    }
  `]
})
export class ContactComponent {
  constructor(private langService: LanguageService) { }

  t(key: string) {
    return this.langService.translate(key);
  }
}
